import { useIntl } from "react-intl";

import { SelectItem, Select } from "@/components/Select";

import { CountryFlag } from "./CountryFlag";
import type { PhoneCountry } from "./types";
import { getDialCode } from "./utils/phoneUtils";

type DialCodeButtonProps = {
  country: PhoneCountry;
  onOpen: () => void;
};

export function DialCodeButton({ country, onOpen }: DialCodeButtonProps) {
  const intl = useIntl();
  const dialCode = getDialCode(country);

  return (
    <div className="min-w-26">
      <Select
        open={false}
        onOpen={onOpen}
        value={dialCode}
        label={intl.formatMessage({
          defaultMessage: "Code",
          description:
            "Label for the country code button in the phone number input",
        })}
      >
        <SelectItem value={dialCode}>
          <div className="flex items-center gap-1">
            <CountryFlag
              country={country}
              className="max-h-3 w-full max-w-4 shrink-0"
            />
            <span dir="ltr">{dialCode}</span>
          </div>
        </SelectItem>
      </Select>
    </div>
  );
}
